export const OPEN_IN_APP = 'results/OPEN_IN_APP'

export const REFRESH_PROFILE = 'results/REFRESH_PROFILE'
export const REFRESH_PROFILE_ERROR = 'results/REFRESH_PROFILE_ERROR'
export const REFRESH_PROFILE_SUCCESS = 'results/REFRESH_PROFILE_SUCCESS'

export const REFRESH_PROFILES = 'results/REFRESH_PROFILES'
export const REFRESH_PROFILES_ERROR = 'results/REFRESH_PROFILES_ERROR'
export const REFRESH_PROFILES_SUCCESS = 'results/REFRESH_PROFILES_SUCCESS'
